<template>
  <div class="periods-item" @click="onPeriodsClick">
    <ImageClip
      class="periods-item_cover"
      :src="item.cover_img"
      :width="coverWidth - 2"
      :height="coverHeight"
      :radius="8"
    ></ImageClip>
    <div class="periods-item_course">{{ item.pack_num }}课时</div>
    <div class="periods-item_body">
      <div class="periods-item_title">
        <div class="periods-item_type">
          {{ (item.type || item.sign_type) | enum('PeriodsType') }}
        </div>
        <div class="periods-item_content">{{ item.name }}</div>
      </div>
      <div class="periods-item_footer">
        <span class="periods-item_sales"> {{ item.sales_base + item.sales_num }}人已购买 </span>
        <CurrencyNew
          :price="item.sale_price"
          :priceUnderline="item.original_price == item.sale_price ? 0 : item.original_price"
          :priceTwo="true"
        ></CurrencyNew>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PeriodsItem',
  props: {
    item: {
      type: Object,
    },
    coverWidth: {
      type: Number,
      default: 282,
    },
    coverHeight: {
      type: Number,
      default: 188,
    },
  },
  methods: {
    onPeriodsClick() {
      let query = {
        nav: this.$route.query.nav,
        title: this.$route.query.title,
        recommend: this.$route.query.recommend,
      };
      this.$router.push({
        name: 'PeriodsDetail',
        params: {
          id: this.item.id,
        },
        query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.periods-item {
  width: 282px;
  height: 298px;
  background: #ffffff;
  border-radius: 8px;
  float: left;
  margin: 0 24px 32px 0;
  cursor: pointer;
  position: relative;
  // border: 1px solid #ededed;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .periods-item_cover {
      ::v-deep {
        img {
          transform: scale(1.1);
        }
      }
    }
  }

  &:nth-child(4n) {
    margin-right: 0;
  }
}
.periods-item_cover {
  margin-bottom: 16px;
  border-radius: 8px 8px 0 0 !important;

  ::v-deep {
    img {
      transform: scale(1);
      transition: all 0.5s;
    }
  }
}
.periods-item_course {
  position: absolute;
  width: 53px;
  height: 24px;
  right: 10px;
  top: 154px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 24px;
}
.periods-item_body {
  padding: 0 16px 19px 16px;
}
.periods-item_title {
  height: 52px;
  color: #333333;
  .periods-item_type {
    float: left;
    text-align: left;
    height: 19px;
    background: #535557;
    border-radius: 0px 4px 7px 4px;
    padding: 1.5px 6px;
    line-height: 20px;
    transform: scale(0.91);
    font-size: 12px;
    color: white;
    margin-right: 6px;
  }
  .periods-item_content {
    display: inline;
    max-width: 196px;
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    line-height: 22px;
  }
}
.periods-item_footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 22px;
  left: 0;
  bottom: 16px;

  ::v-deep {
    .price-wrap {
      margin-bottom: 3px;
      .price-underline {
        margin-right: 11px;
      }
    }
  }
}
.periods-item_sales {
  height: 22px;
  font-size: 13px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: #999999;
  line-height: 22px;
}
</style>
